import React, { useState } from "react";

// Mock Data
let mockTutors = {};
let mockTutorProfiles = {};
try {
  const response = await fetch("https://zentora-backend-dd6w.onrender.com/api/tutors/3", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = await response.json();
  mockTutorProfiles = result.tutorProfiles
  mockTutors = result.tutorSummaries
  console.log("✅ SUCCESS! Fetched tutor profiles:", result);
} catch (err) {
  console.error("❌ Failed to fetch tutors:", err);
  alert("❌ Failed to fetch tutors: " + err.message);
}

// const mockTutors = [
//   { name: "Alex Johnson", subjects: "Math, Physics", status: "Active" },
//   { name: "Emily Lee", subjects: "English, History", status: "Pending" },
//   { name: "Chris Kim", subjects: "Biology, Chemistry", status: "Active" },
// ];
const mockClients = [
  { name: "Jane Doe", status: "Premium", sessions: 12 },
  { name: "John Smith", status: "Standard", sessions: 5 },
  { name: "Sarah Lee", status: "Premium", sessions: 9 },
];
const mockStats = {
  totalTutors: 42,
  activeSessions: 17,
  satisfaction: "97%",
  revenue: "$12,400",
};
const mockActivity = [
  { time: "2m ago", action: "Tutor Alex Johnson uploaded a new document." },
  { time: "10m ago", action: "New client matched with Emily Lee." },
  { time: "1h ago", action: "Session completed: Chris Kim & Jane Doe." },
  { time: "2h ago", action: "Revenue report generated." },
];
const mockInsights = [
  "Tutor satisfaction remains above 95% for the third month.",
  "Revenue up 12% compared to last month.",
  "Most active subject: Mathematics.",
];
// const mockTutorProfiles = [
//   {
//     name: "Alex Johnson",
//     timezone: "EST",
//     subjects: "Math, Physics",
//     teachingStyle: "Visual, Interactive",
//     teachingPace: "Moderate",
//     sessionFormat: "Online, 1-on-1",
//     experienceLevel: "5 years",
//     tutoringApproach: "Conceptual, Problem-Solving",
//     availability: "Weekdays 4-8pm",
//     languages: "English, Spanish",
//     background: "B.Sc. Physics, Tutoring since 2018",
//     helpFocus: "Exam Prep, Homework Help",
//   },
//   {
//     name: "Emily Lee",
//     timezone: "PST",
//     subjects: "English, History",
//     teachingStyle: "Discussion-Based",
//     teachingPace: "Flexible",
//     sessionFormat: "Online, Group",
//     experienceLevel: "2 years",
//     tutoringApproach: "Socratic, Encouraging",
//     availability: "Weekends 10am-2pm",
//     languages: "English, Korean",
//     background: "B.A. English Literature",
//     helpFocus: "Essay Writing, Reading Comprehension",
//   },
//   {
//     name: "Chris Kim",
//     timezone: "CST",
//     subjects: "Biology, Chemistry",
//     teachingStyle: "Hands-On, Visual",
//     teachingPace: "Fast",
//     sessionFormat: "In-Person, 1-on-1",
//     experienceLevel: "3 years",
//     tutoringApproach: "Experimental, Step-by-Step",
//     availability: "Mon/Wed/Fri 5-7pm",
//     languages: "English, Mandarin",
//     background: "M.Sc. Biology",
//     helpFocus: "Lab Skills, Test Prep",
//   },
// ];
const mockClientProfiles = [
  {
    name: "Jane Doe",
    email: "jane.doe@email.com",
    subjectsNeeded: "Math, Physics",
    gradeLevel: "10th Grade",
    preferredSessionTimes: "Weekdays 5-7pm",
    learningGoals: "Improve grades, SAT prep",
    challenges: "Test anxiety, time management",
    preferredTutorQualities: "Patient, clear explanations",
    communicationPreferences: "Email, SMS",
    parentContact: "Mary Doe, (555) 123-4567",
    additionalNotes: "Prefers female tutors",
  },
  {
    name: "John Smith",
    email: "john.smith@email.com",
    subjectsNeeded: "English, History",
    gradeLevel: "11th Grade",
    preferredSessionTimes: "Weekends 10am-12pm",
    learningGoals: "Essay writing, AP exam prep",
    challenges: "Procrastination",
    preferredTutorQualities: "Motivational, organized",
    communicationPreferences: "SMS",
    parentContact: "Robert Smith, (555) 987-6543",
    additionalNotes: "Needs help with deadlines",
  },
  {
    name: "Sarah Lee",
    email: "sarah.lee@email.com",
    subjectsNeeded: "Biology, Chemistry",
    gradeLevel: "9th Grade",
    preferredSessionTimes: "Mon/Wed 4-6pm",
    learningGoals: "Build study habits, understand labs",
    challenges: "Shyness in class",
    preferredTutorQualities: "Friendly, encouraging",
    communicationPreferences: "Email",
    parentContact: "Linda Lee, (555) 222-3333",
    additionalNotes: "Prefers group sessions",
  },
];

export default function ExecutiveDashboard() {
  const [modal, setModal] = useState(null);
  const [profileTutor, setProfileTutor] = useState(null);
  const [profileClient, setProfileClient] = useState(null);
  const closeModal = () => {
    setModal(null);
    setProfileTutor(null);
    setProfileClient(null);
  };
  return (
    <div className="dashboard-bg executive-dashboard-bg">
      {/* Header */}
      <div className="dashboard-header">
        <img src="/zentora-transparent-white.png" alt="Zentora Logo" className="dashboard-logo" />
        <h1 className="dashboard-title pp-editorial-italic">Executive Dashboard</h1>
      </div>
      <div className="dashboard-content">
        {/* Quick Actions */}
        <section className="dashboard-card quick-actions-card glassmorphism animate-fadein">
          <h2 className="dashboard-section-title sans-header">Quick Actions</h2>
          <div className="dashboard-section-subtitle">Get started with common tasks</div>
          <div className="quick-actions-btn-row">
            <button className="quick-action-btn" onClick={() => setModal("addTutor")}>
              <span className="quick-action-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <circle cx="11" cy="7.5" r="4" stroke="#23273a" strokeWidth="1.5" />
                  <path
                    d="M3.5 18c0-2.485 3.134-4.5 7-4.5s7 2.015 7 4.5"
                    stroke="#a259ff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              Add Tutor
            </button>
            <button className="quick-action-btn" onClick={() => setModal("viewReports")}>
              <span className="quick-action-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <rect x="4" y="12" width="3" height="6" rx="1.5" fill="#fff" stroke="#23273a" strokeWidth="1.2" />
                  <rect x="9" y="8" width="3" height="10" rx="1.5" fill="#fff" stroke="#a259ff" strokeWidth="1.2" />
                  <rect x="14" y="4" width="3" height="14" rx="1.5" fill="#fff" stroke="#4f8cff" strokeWidth="1.2" />
                </svg>
              </span>
              View Reports
            </button>
            <button className="quick-action-btn" onClick={() => setModal("messageAll")}>
              <span className="quick-action-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <rect x="3" y="5" width="16" height="12" rx="3" stroke="#23273a" strokeWidth="1.5" fill="#fff" />
                  <path d="M5 7l6 5 6-5" stroke="#a259ff" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </span>
              Message All Tutors
            </button>
            <button className="quick-action-btn" onClick={() => setModal("manageClients")}>
              <span className="quick-action-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                  <circle cx="7" cy="9" r="3" stroke="#23273a" strokeWidth="1.5" fill="#fff" />
                  <circle cx="15" cy="9" r="3" stroke="#a259ff" strokeWidth="1.5" fill="#fff" />
                  <path
                    d="M3.5 18c0-2.485 2.239-4.5 5-4.5s5 2.015 5 4.5"
                    stroke="#23273a"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M11.5 18c0-2.485 2.239-4.5 5-4.5s5 2.015 5 4.5"
                    stroke="#a259ff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              Manage Clients
            </button>
          </div>
        </section>
        {/* Main Cards Row */}
        <div className="dashboard-row dashboard-row-main">
          {/* Platform Analytics */}
          <section className="dashboard-card analytics-card glassmorphism animate-fadein">
            <h2 className="dashboard-section-title sans-header">Platform Analytics</h2>
            <div className="analytics-stats-grid">
              <div className="analytics-stat-card">
                <div className="analytics-stat-label">Total Tutors</div>
                <div className="analytics-stat-value">{mockStats.totalTutors}</div>
              </div>
              <div className="analytics-stat-card">
                <div className="analytics-stat-label">Active Sessions</div>
                <div className="analytics-stat-value">{mockStats.activeSessions}</div>
              </div>
              <div className="analytics-stat-card">
                <div className="analytics-stat-label">Satisfaction</div>
                <div className="analytics-stat-value">{mockStats.satisfaction}</div>
              </div>
              <div className="analytics-stat-card">
                <div className="analytics-stat-label">Revenue</div>
                <div className="analytics-stat-value">
                  <span className="dollar">$</span>
                  {mockStats.revenue.replace("$", "")}
                </div>
              </div>
            </div>
          </section>
          {/* Tutor Management */}
          <section className="dashboard-card tutors-card glassmorphism animate-fadein">
            <h2 className="dashboard-section-title sans-header">Tutor Management</h2>
            <input className="dashboard-search" placeholder="Search tutors..." />
            <ul className="dashboard-list">
              {mockTutors.map((tutor, i) => (
                <li key={i} className="dashboard-list-item">
                  <span className="tutor-name">{tutor.name}</span>
                  <span className="tutor-subjects">{tutor.subjects}</span>
                  <span className={`tutor-status status-${tutor.status.toLowerCase()}`}>{tutor.status}</span>
                  <div className="mini-btn-group">
                    <button className="mini-btn" onClick={() => setProfileTutor(mockTutorProfiles[i])}>
                      View
                    </button>
                    <button className="mini-btn">Message</button>
                    <button className="mini-btn mini-btn-danger">Suspend</button>
                  </div>
                </li>
              ))}
            </ul>
          </section>
          {/* Client Management */}
          <section className="dashboard-card clients-card glassmorphism animate-fadein">
            <h2 className="dashboard-section-title sans-header">Client Management</h2>
            <ul className="dashboard-list">
              {mockClients.map((client, i) => (
                <li key={i} className="dashboard-list-item">
                  <span className="client-name">{client.name}</span>
                  <span className="client-status-badge status-premium">{client.status}</span>
                  <span className="client-sessions">Sessions: {client.sessions}</span>
                  <div className="mini-btn-group">
                    <button className="mini-btn" onClick={() => setProfileClient(mockClientProfiles[i])}>
                      View
                    </button>
                    <button className="mini-btn">Message</button>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        </div>
        {/* Bottom Row: Activity & Insights */}
        <div className="dashboard-row dashboard-row-bottom">
          {/* Recent Activity */}
          <section className="dashboard-card activity-card glassmorphism animate-fadein">
            <h2 className="dashboard-section-title sans-header">Recent Activity</h2>
            <ul className="dashboard-list activity-list">
              {mockActivity.map((item, i) => (
                <li key={i} className="dashboard-list-item activity-list-item">
                  <span className="activity-time">{item.time}</span>
                  <span className="activity-action">{item.action}</span>
                </li>
              ))}
            </ul>
          </section>
          {/* Executive Insights */}
          <section className="dashboard-card insights-card glassmorphism animate-fadein">
            <h2 className="dashboard-section-title sans-header">Executive Intelligence Dashboard</h2>
            <div className="exec-charts-grid">
              {/* Tutor Retention Rate (Line Chart) */}
              <div className="exec-chart-card exec-chart-large">
                <div className="exec-chart-title">Tutor Retention Rate</div>
                <svg width="220" height="100" viewBox="0 0 220 100">
                  <rect x="0" y="0" width="220" height="100" rx="18" fill="#f7f6ff" />
                  <polyline
                    points="0,90 30,70 60,60 90,55 120,40 150,30 180,25 210,20"
                    fill="none"
                    stroke="#4f8cff"
                    strokeWidth="4"
                    strokeLinejoin="round"
                  />
                  <circle cx="210" cy="20" r="7" fill="#a259ff" />
                </svg>
                <div className="exec-chart-label">89% retention</div>
              </div>
              {/* Client Churn (Bar Chart) */}
              <div className="exec-chart-card exec-chart-large">
                <div className="exec-chart-title">Client Churn</div>
                <svg width="220" height="100" viewBox="0 0 220 100">
                  <rect x="0" y="0" width="220" height="100" rx="18" fill="#f7f6ff" />
                  <rect x="30" y="60" width="20" height="30" rx="4" fill="#ffb3b3" />
                  <rect x="70" y="40" width="20" height="50" rx="4" fill="#a259ff" />
                  <rect x="110" y="30" width="20" height="60" rx="4" fill="#4f8cff" />
                  <rect x="150" y="20" width="20" height="70" rx="4" fill="#bbaaff" />
                  <rect x="190" y="50" width="20" height="40" rx="4" fill="#a259ff" />
                </svg>
                <div className="exec-chart-label">11% churn</div>
              </div>
              {/* Top Referral Sources (Pie Chart) */}
              <div className="exec-chart-card exec-chart-large">
                <div className="exec-chart-title">Top Referral Sources</div>
                <svg width="120" height="100" viewBox="0 0 120 100">
                  <g transform="translate(60,50)">
                    <path d="M0,0 L40,0 A40,40 0 0,1 12.36,38.05 Z" fill="#a259ff" />
                    <path d="M0,0 L12.36,38.05 A40,40 0 1,1 -40,0 Z" fill="#4f8cff" />
                    <path d="M0,0 L-40,0 A40,40 0 0,1 0,-40 Z" fill="#bbaaff" />
                  </g>
                </svg>
                <div className="exec-chart-label">Social 25% • Web 50% • Email 25%</div>
              </div>
              {/* Session Growth by Region (Area Chart) */}
              <div className="exec-chart-card exec-chart-large">
                <div className="exec-chart-title">Session Growth by Region</div>
                <svg width="220" height="100" viewBox="0 0 220 100">
                  <rect x="0" y="0" width="220" height="100" rx="18" fill="#f7f6ff" />
                  <polygon points="0,90 30,80 60,70 90,60 120,50 150,40 180,30 210,20 210,100 0,100" fill="#a259ff33" />
                  <polyline
                    points="0,90 30,80 60,70 90,60 120,50 150,40 180,30 210,20"
                    fill="none"
                    stroke="#4f8cff"
                    strokeWidth="3"
                  />
                </svg>
                <div className="exec-chart-label">+32% West • +18% East</div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* Modals for Quick Actions and Tutor/Client Profile */}
      {modal && (
        <div className="dashboard-modal-overlay animate-fadein" onClick={closeModal}>
          <div className="dashboard-modal animate-pop" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeModal}>
              ×
            </button>
            {modal === "addTutor" && (
              <div>
                <h3>Add Tutor</h3>
                <p>(Demo) Enter tutor details to add a new tutor to the platform.</p>
                <input
                  type="text"
                  placeholder="Name"
                  className="zentora-input"
                  style={{ width: "100%", marginBottom: 8 }}
                />
                <input
                  type="text"
                  placeholder="Subjects"
                  className="zentora-input"
                  style={{ width: "100%", marginBottom: 8 }}
                />
                <button className="zentora-btn modal-action-btn">Add Tutor</button>
              </div>
            )}
            {modal === "viewReports" && (
              <div>
                <h3>View Reports</h3>
                <p>(Demo) Access platform analytics and export reports.</p>
                <button className="zentora-btn modal-action-btn">Download Report</button>
              </div>
            )}
            {modal === "messageAll" && (
              <div>
                <h3>Message All Tutors</h3>
                <p>(Demo) Send a message to all tutors on the platform.</p>
                <textarea
                  rows={3}
                  placeholder="Type your message..."
                  className="zentora-input"
                  style={{ width: "100%", marginTop: 8 }}
                />
                <button className="zentora-btn modal-action-btn">Send</button>
              </div>
            )}
            {modal === "manageClients" && (
              <div>
                <h3>Manage Clients</h3>
                <p>(Demo) View and manage client accounts.</p>
                <button className="zentora-btn modal-action-btn">Go to Client Management</button>
              </div>
            )}
          </div>
        </div>
      )}
      {profileTutor && (
        <div className="dashboard-modal-overlay animate-fadein" onClick={closeModal}>
          <div className="dashboard-modal animate-pop profile-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeModal}>
              ×
            </button>
            <h3 style={{ marginBottom: 18, color: "#4f8cff", fontFamily: "FK Grotesk" }}>Tutor Profile</h3>
            <div style={{ fontWeight: 600, fontSize: "1.18rem", marginBottom: 10, color: "#23273a" }}>
              {profileTutor.name}
            </div>
            <div className="profile-info-list">
              <div>
                <span>Timezone:</span> <span>{profileTutor.timezone}</span>
              </div>
              <div>
                <span>Subjects:</span> <span>{profileTutor.subjects}</span>
              </div>
              <div>
                <span>Teaching Style:</span> <span>{profileTutor.teachingStyle}</span>
              </div>
              <div>
                <span>Teaching Pace:</span> <span>{profileTutor.teachingPace}</span>
              </div>
              <div>
                <span>Session Format:</span> <span>{profileTutor.sessionFormat}</span>
              </div>
              <div>
                <span>Experience Level:</span> <span>{profileTutor.experienceLevel}</span>
              </div>
              <div>
                <span>Tutoring Approach:</span> <span>{profileTutor.tutoringApproach}</span>
              </div>
              <div>
                <span>Availability:</span> <span>{profileTutor.availability}</span>
              </div>
              <div>
                <span>Languages:</span> <span>{profileTutor.languages}</span>
              </div>
              <div>
                <span>Background:</span> <span>{profileTutor.background}</span>
              </div>
              <div>
                <span>Help Focus:</span> <span>{profileTutor.helpFocus}</span>
              </div>
            </div>
          </div>
        </div>
      )}
      {profileClient && (
        <div className="dashboard-modal-overlay animate-fadein" onClick={closeModal}>
          <div className="dashboard-modal animate-pop profile-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeModal}>
              ×
            </button>
            <h3 style={{ marginBottom: 18, color: "#4f8cff", fontFamily: "FK Grotesk" }}>Client Profile</h3>
            <div style={{ fontWeight: 600, fontSize: "1.18rem", marginBottom: 10, color: "#23273a" }}>
              {profileClient.name}
            </div>
            <div className="profile-info-list">
              <div>
                <span>Email:</span> <span>{profileClient.email}</span>
              </div>
              <div>
                <span>Subjects Needed:</span> <span>{profileClient.subjectsNeeded}</span>
              </div>
              <div>
                <span>Grade Level:</span> <span>{profileClient.gradeLevel}</span>
              </div>
              <div>
                <span>Preferred Session Times:</span> <span>{profileClient.preferredSessionTimes}</span>
              </div>
              <div>
                <span>Learning Goals:</span> <span>{profileClient.learningGoals}</span>
              </div>
              <div>
                <span>Challenges:</span> <span>{profileClient.challenges}</span>
              </div>
              <div>
                <span>Preferred Tutor Qualities:</span> <span>{profileClient.preferredTutorQualities}</span>
              </div>
              <div>
                <span>Communication Preferences:</span> <span>{profileClient.communicationPreferences}</span>
              </div>
              <div>
                <span>Parent/Guardian Contact:</span> <span>{profileClient.parentContact}</span>
              </div>
              <div>
                <span>Additional Notes:</span> <span>{profileClient.additionalNotes}</span>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Styles */}
      <style jsx>{`
        .dashboard-bg {
          min-height: 100vh;
          background: linear-gradient(120deg, #f3f3f7 0%, #e9e6ff 100%);
          font-family: "FK Grotesk", sans-serif;
          padding: 0 0 60px 0;
          width: 100%;
          box-sizing: border-box;
          overflow-x: hidden;
        }
        .dashboard-header {
          display: flex;
          align-items: center;
          gap: 18px;
          padding: 48px 0 24px 0;
          justify-content: center;
        }
        .dashboard-logo {
          width: 64px;
          height: 64px;
          object-fit: contain;
          filter: drop-shadow(0 8px 32px #a259ff44) drop-shadow(0 0 12px #fff8);
        }
        .dashboard-title {
          font-family: "PP Editorial New Italic", "PP Editorial", serif;
          font-size: 2.6rem;
          color: #23273a;
          letter-spacing: -0.03em;
          font-style: italic;
        }
        .pp-editorial-italic {
          font-family: "PP Editorial New Italic", "PP Editorial", serif;
          font-style: italic;
        }
        .dashboard-content {
          display: flex;
          flex-direction: column;
          gap: 32px;
          max-width: 1200px;
          margin: 0 auto;
          align-items: stretch;
          padding-left: max(32px, env(safe-area-inset-left));
          padding-right: max(32px, env(safe-area-inset-right));
          box-sizing: border-box;
          width: 100%;
        }
        .dashboard-card {
          background: rgba(255, 255, 255, 0.92);
          border-radius: 18px;
          box-shadow: 0 8px 40px #a259ff18, 0 0 0 2px #4f8cff11;
          padding: 36px 28px 32px 28px;
          display: flex;
          flex-direction: column;
          gap: 22px;
          min-height: 240px;
          box-sizing: border-box;
        }
        .glassmorphism {
          background: rgba(255, 255, 255, 0.55) !important;
          backdrop-filter: blur(16px) saturate(1.2);
          border: 1.5px solid #e9e6ff88;
        }
        .dashboard-section-title {
          font-family: "FK Grotesk", sans-serif;
          font-size: 1.32rem;
          color: #4f8cff;
          margin-bottom: 8px;
          font-weight: 800;
          letter-spacing: -0.01em;
        }
        .dashboard-section-subtitle {
          color: #8a8e9c;
          font-size: 1.05rem;
          margin-bottom: 18px;
        }
        .sans-header {
          font-family: "FK Grotesk", sans-serif !important;
          font-style: normal !important;
          font-weight: 800;
          letter-spacing: -0.01em;
        }
        .quick-actions-card {
          align-items: center;
          text-align: center;
        }
        .quick-actions-btn-row {
          display: flex;
          gap: 24px;
          flex-wrap: wrap;
          justify-content: center;
        }
        .quick-action-btn {
          font-family: "FK Grotesk", sans-serif !important;
          display: flex;
          align-items: center;
          gap: 10px;
          background: #bbaaff;
          color: #fff;
          border: 1.5px solid #e0dfff;
          border-radius: 14px;
          font-size: 1.13rem;
          font-weight: 600;
          padding: 18px 32px;
          cursor: pointer;
          box-shadow: 0 4px 18px #a259ff22, 0 1.5px 0 #fff8 inset;
          transition: background 0.18s, transform 0.18s, box-shadow 0.18s;
          position: relative;
          outline: none;
          min-width: 180px;
        }
        .quick-action-btn:active {
          transform: scale(0.97);
          box-shadow: 0 2px 8px #a259ff22;
        }
        .quick-action-btn:hover,
        .quick-action-btn:focus {
          background: #a084e8;
          transform: translateY(-2px) scale(1.045);
          box-shadow: 0 8px 32px #a259ff22, 0 1.5px 0 #fff8 inset;
        }
        .quick-action-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px #a259ff11;
          margin-right: 10px;
          font-size: 1.3em;
        }
        .dashboard-row {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 32px;
          width: 100%;
        }
        .dashboard-row-main {
          margin-bottom: 0;
        }
        .dashboard-row-bottom {
          margin-top: 0;
        }
        .analytics-charts-row {
          display: none;
        }
        .analytics-stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(2, 1fr);
          gap: 28px;
          margin-top: 18px;
        }
        .analytics-stat-card {
          background: rgba(255, 255, 255, 0.96);
          border-radius: 20px;
          box-shadow: 0 2px 16px #a259ff18, 0 0 0 1.5px #e0dfff;
          padding: 36px 0 28px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-width: 0;
          transition: box-shadow 0.18s, background 0.18s;
        }
        .analytics-stat-label {
          color: #4f8cff;
          font-size: 1.13rem;
          font-weight: 600;
          margin-bottom: 10px;
          text-align: center;
          letter-spacing: 0.01em;
        }
        .analytics-stat-value {
          color: #a259ff;
          font-size: 2rem;
          font-weight: 800;
          text-align: center;
          letter-spacing: -0.01em;
        }
        .dashboard-search {
          margin-bottom: 12px;
          padding: 12px 18px;
          border-radius: 10px;
          border: 1.5px solid #e0dfff;
          font-size: 1.05rem;
          width: 100%;
        }
        .dashboard-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .dashboard-list-item {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          background: #f3f3f7;
          border-radius: 12px;
          padding: 14px 14px;
          font-size: 1.05rem;
          min-height: 48px;
          flex-wrap: wrap;
          max-width: 100%;
        }
        .tutor-name {
          font-weight: 600;
          color: #23273a;
        }
        .tutor-subjects {
          color: #8a8e9c;
        }
        .tutor-status {
          margin-left: auto;
          font-weight: 600;
          padding: 4px 12px;
          border-radius: 8px;
        }
        .status-active {
          background: #e6f7ee;
          color: #30d158;
        }
        .status-pending {
          background: #f7f3e6;
          color: #a259ff;
        }
        .mini-btn-group {
          display: flex;
          gap: 16px;
          margin-left: 12px;
          flex-wrap: wrap;
          justify-content: flex-end;
          max-width: 100%;
        }
        .mini-btn {
          font-family: "FK Grotesk", sans-serif !important;
          background: #bbaaff;
          color: #fff;
          border: 1.5px solid #e0dfff;
          border-radius: 14px;
          font-size: 1.08rem;
          font-weight: 700;
          padding: 12px 28px;
          cursor: pointer;
          box-shadow: 0 4px 18px #a259ff18, 0 1.5px 0 #fff8 inset;
          transition: background 0.18s, transform 0.18s, box-shadow 0.18s;
          align-self: flex-end;
          letter-spacing: -0.01em;
        }
        .mini-btn:hover {
          background: #a084e8;
          transform: translateY(-2px) scale(1.045);
          box-shadow: 0 8px 32px #a259ff22, 0 1.5px 0 #fff8 inset;
        }
        .mini-btn-danger {
          background: #ffb3b3;
          color: #a259ff;
          border: 1.5px solid #ffb3b3;
        }
        .client-name {
          font-weight: 600;
          color: #23273a;
        }
        .client-status-badge {
          background: #e6f7ee;
          color: #30d158;
          font-weight: 600;
          border-radius: 8px;
          padding: 4px 12px;
          margin-left: 12px;
        }
        .client-sessions {
          color: #8a8e9c;
          margin-left: 12px;
        }
        .activity-list-item {
          background: #f7f6ff;
          border-left: 4px solid #a259ff;
          animation: fadein 0.7s cubic-bezier(0.4, 0, 0.2, 1);
          min-height: 40px;
        }
        .activity-time {
          color: #4f8cff;
          font-weight: 600;
          min-width: 60px;
        }
        .activity-action {
          color: #23273a;
        }
        .insights-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .insight-item {
          color: #4f8cff;
          font-size: 1.05rem;
          background: #f3f3f7;
          border-radius: 8px;
          padding: 10px 14px;
        }
        @keyframes fadein {
          from {
            opacity: 0;
            transform: translateY(24px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: none;
          }
        }
        .animate-fadein {
          animation: fadein 0.7s cubic-bezier(0.4, 0, 0.2, 1);
        }
        @keyframes pop {
          from {
            opacity: 0;
            transform: scale(0.92);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-pop {
          animation: pop 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .dashboard-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(60, 40, 120, 0.18);
          z-index: 1000;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .dashboard-modal {
          background: #fff;
          border-radius: 18px;
          box-shadow: 0 8px 40px #a259ff33, 0 0 0 2px #4f8cff11;
          padding: 36px 32px 28px 32px;
          min-width: 320px;
          max-width: 95vw;
          position: relative;
        }
        .modal-close-btn {
          position: absolute;
          top: 12px;
          right: 18px;
          background: none;
          border: none;
          font-size: 2rem;
          color: #a259ff;
          cursor: pointer;
        }
        .zentora-input {
          font-family: "FK Grotesk", sans-serif;
          font-size: 1.05rem;
          padding: 10px 16px;
          border-radius: 10px;
          border: 1.5px solid #e0dfff;
          background: #f7f6ff;
          color: #23273a;
          outline: none;
          transition: border 0.18s, box-shadow 0.18s;
          box-shadow: 0 2px 8px #a259ff11;
          margin-bottom: 0;
        }
        .zentora-input:focus {
          border: 1.5px solid #a259ff;
          box-shadow: 0 0 0 2px #a259ff22;
          background: #fff;
        }
        .zentora-btn,
        .modal-action-btn {
          font-family: "FK Grotesk", sans-serif !important;
          background: #bbaaff;
          color: #fff;
          border: 1.5px solid #e0dfff;
          border-radius: 10px;
          font-size: 1.05rem;
          font-weight: 600;
          padding: 10px 28px;
          cursor: pointer;
          box-shadow: 0 4px 18px #a259ff22;
          transition: background 0.18s, transform 0.18s;
          margin-left: 0;
          margin-top: 10px;
          display: inline-block;
        }
        .zentora-btn:hover,
        .modal-action-btn:hover {
          background: #a084e8;
          transform: translateY(-2px) scale(1.04);
        }
        *,
        *:before,
        *:after {
          box-sizing: inherit;
        }
        @media (max-width: 1200px) {
          .dashboard-content {
            padding-left: 8px;
            padding-right: 8px;
          }
          .dashboard-row {
            grid-template-columns: 1fr;
            gap: 24px;
          }
        }
        @media (max-width: 900px) {
          .dashboard-content {
            padding-left: 4px;
            padding-right: 4px;
          }
          .dashboard-card {
            min-height: 0;
            padding: 18px 4px 10px 4px;
          }
          .dashboard-list-item {
            flex-direction: column;
            align-items: flex-start;
          }
          .mini-btn-group {
            justify-content: flex-start;
            width: 100%;
          }
          .analytics-stats-grid {
            grid-template-columns: 1fr;
            grid-template-rows: none;
            gap: 16px;
          }
          .exec-charts-grid {
            grid-template-columns: 1fr;
            grid-template-rows: none;
            gap: 18px;
          }
          .exec-chart-card.exec-chart-large {
            min-width: 0;
            width: 100%;
          }
        }
        @media (max-width: 600px) {
          .analytics-stats-grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }
        }
        .profile-info-list {
          margin-top: 8px;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .profile-info-list div {
          display: flex;
          justify-content: flex-start;
          align-items: baseline;
          font-size: 1.08rem;
          color: #8a8e9c;
        }
        .profile-info-list div span:first-child {
          min-width: 170px;
          color: #8a8e9c;
          font-weight: 500;
        }
        .profile-info-list div span:last-child {
          color: #a259ff;
          margin-left: 8px;
          font-weight: 600;
        }
        .profile-modal {
          max-width: 420px;
        }
        .exec-charts-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: 1fr 1fr;
          gap: 28px;
          width: 100%;
          height: 100%;
          margin-top: 0;
        }
        .exec-chart-card {
          background: rgba(255, 255, 255, 0.96);
          border-radius: 16px;
          box-shadow: 0 2px 12px #a259ff11, 0 0 0 1.5px #e0dfff;
          padding: 18px 12px 12px 12px;
          min-width: 0;
          min-height: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          gap: 6px;
          width: 100%;
          height: 100%;
        }
        .exec-chart-card.exec-chart-large {
          background: rgba(255, 255, 255, 0.96);
          border-radius: 16px;
          box-shadow: 0 2px 12px #a259ff11, 0 0 0 1.5px #e0dfff;
          padding: 18px 12px 12px 12px;
          min-width: 0;
          min-height: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          gap: 6px;
          width: 100%;
          height: 100%;
        }
        .exec-chart-title {
          color: #4f8cff;
          font-size: 1.01rem;
          font-weight: 600;
          margin-bottom: 4px;
          text-align: center;
        }
        .exec-chart-label {
          color: #a259ff;
          font-size: 1.01rem;
          font-weight: 700;
          margin-top: 2px;
          text-align: center;
        }
        .dollar {
          font-family: Arial, system-ui, sans-serif !important;
          letter-spacing: 0;
        }
      `}</style>
    </div>
  );
}
